module.exports = __webpack_public_path__ + "static/img/87074G_1_R_20220623_fit.7968397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/87074G_1_R_20220623_fit.png
// module id = bg80
// module chunks = 0